import { useTranslation } from 'react-i18next'
import { formatDate } from '../utils/format'
import type { AppError } from './ErrorContext'

interface ErrorPageProps {
  error: AppError
  onReset: () => void
}

export function ErrorPage({ error, onReset }: ErrorPageProps) {
  const { t } = useTranslation()
  const fieldErrors = error.fieldErrors ? Object.entries(error.fieldErrors) : []

  return (
    <div className="error-page">
      <h2>{t('error.title')}</h2>
      <p className="error-page-message">
        {error.status != null && <span className="error-page-status">HTTP {error.status}</span>}
        {error.message}
      </p>

      {fieldErrors.length > 0 && (
        <ul className="error-page-fields">
          {fieldErrors.map(([field, message]) => (
            <li key={field}>
              <strong>{field}:</strong> {message}
            </li>
          ))}
        </ul>
      )}

      {(error.path || error.timestamp) && (
        <p className="muted">
          {error.path && <>{t('error.path')}: {error.path}</>}
          {error.path && error.timestamp && ' · '}
          {error.timestamp && <>{t('error.timestamp')}: {formatDate(error.timestamp)}</>}
        </p>
      )}

      <button onClick={onReset}>{t('error.backToApp')}</button>
    </div>
  )
}
